import { useDispatch } from 'react-redux';

import { cardApplicationStartPolling } from '@perpay-web/fintech/actions/entities/cardAccountApplications';
import CardSubmittingAcceptance from '@perpay-web/fintech/components/composite/CardSubmittingAcceptance/CardSubmittingAcceptance';

const CardSubmittingAcceptanceContainer = ({ applicationUuid }) => {
    const dispatch = useDispatch();
    const onMount = () => {
        if (applicationUuid) {
            dispatch(cardApplicationStartPolling(applicationUuid));
        }
    };
    return <CardSubmittingAcceptance onMount={onMount} />;
};
export default CardSubmittingAcceptanceContainer;
